import React, { useState } from 'react'
import { Card, CardBody, Col } from 'reactstrap';
import CommonCardHeader from '../../../CommonComponents/CommonCardHeader/CommonCardHeader';
import { AnimatedHorizontalTabsTitle } from '../../../../Constants/Constants';
import { AnimatedHorizontalTabsSubTitle } from '../../../../Data/UiKits/Tabs';
import AnimatedHorizontalTabsNav from './AnimatedHorizontalTabsNav';
import AnimatedHorizontalTabsContent from './AnimatedHorizontalTabsContent';

const AnimatedHorizontalTabs = () => {
    const [basicTab, setBasicTab] = useState("2");

    return (
      <Col xxl="6">
        <Card>
          <CommonCardHeader title={AnimatedHorizontalTabsTitle} span={AnimatedHorizontalTabsSubTitle} />
          <CardBody className="horizontal-icons-tab">
            <AnimatedHorizontalTabsNav basicTab={basicTab} setBasicTab={setBasicTab} />
            <AnimatedHorizontalTabsContent tabId={basicTab} />
          </CardBody>
        </Card>
      </Col>
    );
}

export default AnimatedHorizontalTabs